import { createHook } from '../index.tsx';
import {
	getCollectionsTourDismissed,
	getTourSpotlightStep,
	getCollectionsIntroductionDismissed,
	getCollectionsIntroductionPrerequisiteDismissalsMet,
} from './collections.tsx';

export const useCollectionsTourDismissed = createHook(getCollectionsTourDismissed);
export const useTourSpotlightStep = createHook(getTourSpotlightStep);
export const useCollectionsIntroductionDismissed = createHook(getCollectionsIntroductionDismissed);
export const useCollectionsIntroductionPrerequisiteDismissalsMet = createHook(
	getCollectionsIntroductionPrerequisiteDismissalsMet,
);
